import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src191552198/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/sitemap/content.tsx");
